import { Alert, Descriptions } from "antd";
import React from "react";
import FinishedSincePassedTable from "../../../../../Pages/Admin/QueueManagement/Queue/Components/FinishedSincePassedTable";
import {
  formatPassedAt,
  formatPassedProgress,
} from "../../../../../Pages/Admin/QueueManagement/Queue/Components/PassedQueueDrawer/PassedQueueDrawer";

// Penjelasan untuk pasien: kapan antrian terlewat dan antrian mana saja yang
// selesai sesudahnya (yang menaikkan hitungan menuju batal otomatis).
const PassedQueueHistory = ({
  title,
  passedAt,
  queuesPassedCount,
  threshold,
  finishedSincePassed,
  isStillPassed = false,
}) => {
  const items = Array.isArray(finishedSincePassed) ? finishedSincePassed : [];
  const counter = queuesPassedCount ?? items.length;

  // Antrian yang terlewat sebelum pencatatan daftar ini aktif tidak di-backfill
  const isIncomplete = items.length < counter;

  return (
    <div className="mb-4">
      <Descriptions
        title={title}
        bordered
        column={1}
        size="small"
        className="mb-3"
        labelStyle={{ width: "20%" }}
      >
        {passedAt && (
          <Descriptions.Item label="Waktu Terlewat">
            {formatPassedAt(passedAt)}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Antrian Selesai Sejak Terlewat">
          {formatPassedProgress(counter, threshold)}
          {isStillPassed && threshold
            ? ` (dibatalkan otomatis dan dibuatkan tiket baru pada ${threshold} antrian)`
            : ""}
        </Descriptions.Item>
      </Descriptions>

      <FinishedSincePassedTable items={items} />

      {isIncomplete && (
        <Alert
          className="mt-2"
          type="info"
          showIcon
          message="Daftar belum lengkap karena antrian ini terlewat sebelum pencatatan daftar antrian diaktifkan."
        />
      )}
    </div>
  );
};

export default PassedQueueHistory;
